const HIDDEN_DOMAIN_KEYWORD = 'eikakapitalforvaltning';

export const isHiddenHomeButtonDomain = (hostname: string): boolean =>
    hostname.toLowerCase().includes(HIDDEN_DOMAIN_KEYWORD);
